import { inject } from '@angular/core';
import { LogLevel, OpenIdConfiguration } from 'angular-auth-oidc-client';

import { ConfigurationService, Stage } from '@mobi/rwc-utils-common-ng-jslib';

import { POST_LOGIN_URL } from './authentication-config.provider';
import { CIP_CONFIG_ID } from './internal/cip-auth.config';

const authority = 'https://login.microsoftonline.com/af7227b1-ac3a-4487-9e9f-ba462bb409d4/v2.0';

/**
 * preprod: https://portal.azure.com/#view/Microsoft_AAD_RegisteredApps/ApplicationMenuBlade/~/ProtectAnAPI/appId/c40e0eb6-3780-4ba5-8d78-17ce0f9bf07f
 * TODO: preprod Realm name should be the same as prod & sit. Viking / Gaia should helps to fix this.
 */
const RWC_B2E_REALM_PREPROD = 'api://c40e0eb6-3780-4ba5-8d78-17ce0f9bf07f/b2e_access';
/**
 * sit:  https://portal.azure.com/#view/Microsoft_AAD_RegisteredApps/ApplicationMenuBlade/~/ProtectAnAPI/appId/ecb69b01-d3e4-4b75-a226-559107c1989d
 * prod: https://portal.azure.com/#view/Microsoft_AAD_RegisteredApps/ApplicationMenuBlade/~/ProtectAnAPI/appId/10b5ce38-c21d-4c00-b215-0d3e2b16da65
 */
const RWC_B2E_REALM = 'b2e_access';
const DEFAULT_SCOPES = ['email', 'profile', 'openid', 'offline_access'];

export const B2eAzureEntraAuthConfig = (): OpenIdConfiguration => {
    const configurationService = inject(ConfigurationService);
    const scope = [...DEFAULT_SCOPES, getScope(configurationService.getSync('stage'))].join(' ');
    const clientId = configurationService.getSync('clientId');
    const logLevel = LogLevel.Warn;

    return {
        authority,
        clientId,
        logLevel,
        scope,
        autoUserInfo: false,
        configId: CIP_CONFIG_ID,
        disableIatOffsetValidation: true,
        ignoreNonceAfterRefresh: true,
        postLoginRoute: sessionStorage.getItem(POST_LOGIN_URL) ?? undefined,
        postLogoutRedirectUri: undefined,
        redirectUrl: window.location.origin + '/login-callback',
        renewTimeBeforeTokenExpiresInSeconds: 10,
        renewUserInfoAfterTokenRenew: true,
        responseType: 'code',
        silentRenew: true,
        startCheckSession: false,
        triggerAuthorizationResultEvent: false,
        useRefreshToken: true
    };
};

function getScope(stage?: Stage): string {
    if (stage === 'preprod' || stage === 'local-dev') {
        return RWC_B2E_REALM_PREPROD;
    }
    return RWC_B2E_REALM;
}
